import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { ConfirmProvider } from './components/ui/ConfirmDialog';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // PAUSE polling when tab is hidden. Without this, every dashboard
      // tab left open in the background continues polling on its
      // refetchInterval — multi-tab users were generating ~6.8 req/sec
      // round-the-clock against the API worker (73k requests in 3h on
      // a quiet account). When user returns to the tab, polling resumes
      // automatically. Apply globally so individual queries don't have
      // to opt in.
      refetchIntervalInBackground: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
